import React, {Component} from "react";
import axios from "axios";
import AccessDeny from "../AccessDeny";
import BPContestFileCreateForVCB from "./vcb/BPContestFileCreateForVCB";
import BPContestFileCreateForAGB from "./agb/BPContestFileCreateForAGB";

class BPContestFileCreate extends Component{


    constructor(props) {
        super(props);
        this.state = {bankCode: ''}
    }
    componentDidMount() {
        axios.get('/api/bankportal/contest/'+this.props?.match?.params?.contestId+'/load')
            .then(resp =>{
                    this.setState({bankCode: resp?.data?.bankCode});
            })
            .catch(error =>{
                console.error('Error loading contest!', error);
            }
        );
    }

    render() {
        const { bankCode } = this.state;
        if('' === bankCode) return <AccessDeny />
        if('VCB' === bankCode) return <BPContestFileCreateForVCB contestId={this.props?.match?.params?.contestId} phaseId={this.props?.match?.params?.phaseId} />
        if('AGB' === bankCode) return <BPContestFileCreateForAGB contestId={this.props?.match?.params?.contestId} phaseId={this.props?.match?.params?.phaseId} />
    }
}
export default BPContestFileCreate;